import type { EmbedEditorPresetConfig, EmbedEditorPresetType } from '../types/preset'

export const embedEditorPresets: Record<EmbedEditorPresetType, EmbedEditorPresetConfig> = {
  default: {
    enableNoteLabel: true,
    showMenuPop: true,
    showRightPanel: true,
    bottomBarVariant: 'full',
  },
  maker: {
    enableNoteLabel: false,
    showMenuPop: false,
    showRightPanel: false,
    bottomBarVariant: 'simplified',
  },
}

export function getEmbedEditorPreset(type: EmbedEditorPresetType): EmbedEditorPresetConfig {
  return embedEditorPresets[type]
}
